import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SupportService } from '../../shared/services/support.service';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
var SupportComponent = (function () {
    function SupportComponent(support, snackBar, translate) {
        this.support = support;
        this.snackBar = snackBar;
        this.translate = translate;
        this.supportForm = new FormGroup({
            subject: new FormControl('', [Validators.required, Validators.minLength(2)]),
            message: new FormControl('', [Validators.required, Validators.minLength(2)]),
        });
    }
    SupportComponent.prototype.ngOnInit = function () {
    };
    SupportComponent.prototype.submitSupportForm = function (e) {
        var _this = this;
        e.preventDefault();
        if (this.supportForm.valid) {
            this.support.sendSupportMessage(this.supportForm.value.subject, this.supportForm.value.message)
                .then(function (result) {
                _this.translate.get('SUPPORT.ALERT.sentSuccess').subscribe(function (message) {
                    var snackBarRef = _this.snackBar.open(message, null, { verticalPosition: 'top', duration: 4000, panelClass: ['b2a-success', 'top'] });
                });
                _this.result = "SUPPORT.sentSuccessMsg";
            })
                .catch(function (error) {
                _this.translate.get('SUPPORT.ALERT.sentError').subscribe(function (message) {
                    var snackBarRef = _this.snackBar.open(message, null, { verticalPosition: 'top', duration: 4000, panelClass: ['b2a-error', 'top'] });
                });
            });
        }
    };
    return SupportComponent;
}());
export { SupportComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/support/support.component.ts.pre-build-optimizer.js